<template>
    <section class="worldcup--promotion">
        <b-container>
            <div class="section__title text-center">
                KHUYẾN MÃI OXBET
            </div>
            <b-row>
                <b-col lg="4" v-for="(item, index) in listPromotion" :key="index" class="seagame--promotion__item">
                    <a class="effect-hover" href="javascript:void(0)" @click="checkPromotion">
                        <img :src="item.thumb" :alt="item.alt">
                    </a>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>
<script>
export default {
    data() {
        return {
            listPromotion: [
                {
                    thumb: '/assets/img/event/seagame/promotion-100.png',
                    alt: 'Khuyến mãi 100%'
                },
                {
                    thumb: '/assets/img/event/seagame/promotion-15.png',
                    alt: 'Khuyến mãi 15%'
                },
                {
                    thumb: '/assets/img/event/seagame/promotion-30.png',
                    alt: 'Khuyến mãi 30%'
                }
            ]
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        }
    },
    methods: {
        checkPromotion() {
            if (this.currentUser) {
                this.$router.push('/user/deposit');
            } else {
                this.$bvModal.show('loginModal');
            }
        }
    }
};
</script>
